import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values = { lockScroll: { type: Boolean, default: true } }

  open() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.remove("hidden")
    if (this.lockScrollValue) document.body.classList.add("overflow-hidden")
  }

  close() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.add("hidden")
    if (this.lockScrollValue) document.body.classList.remove("overflow-hidden")
  }

  backdropClose(event) {
    if (!this.hasPanelTarget) return
    if (event.target === this.panelTarget) this.close()
  }
}
